import * as React from "react";
import {Input as BSInput, InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';

export class Input extends React.Component<any> {
    render() {
        const { name, id, maxLength,value, type, placeholder, addon, onChange, onKeyPress, disabled = false, invalid = false } = this.props;

        const input = (
            <BSInput
                type={type || "text"}
                placeholder={placeholder}
                onChange={(e: any) => onChange(e.target.value, e)}
                onKeyPress={onKeyPress}
                value={value || ""}
                name={name}
                id={id || name}
                disabled={disabled}
                invalid={invalid}
                maxLength={maxLength || "number"}
                //defaultValue={value || "123"}
            />
        );

        if (addon) {
            return (
                <InputGroup>
                    {addon.type == 'prepend' &&
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                                {addon.component}
                            </InputGroupText>
                        </InputGroupAddon>
                    }
                    {input}
                    {addon.type == 'append' &&
                    <InputGroupAddon addonType="append">
                        <InputGroupText>
                            {addon.component}
                        </InputGroupText>
                    </InputGroupAddon>
                    }

                </InputGroup>
            );
        }

        return input;
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/form/fields/Input.tsx